import promotionCodeSymbols from "../symbols/promotionCodes";
export interface IPromotionCode {
  Id: string;
  Created: Date;
  Expires: Date;
  StartDate: Date;
  MinimumSpend: number | null;
  Code: string;
  Amount: number;
  Percentage: number;
  PromoCodeType: string;
  CreatedFor?: string;
  Active: boolean;
  FirstName?: string;
  LastName?: string;
  Email?: string;
  UseType?: string;
  DiscountType?: string;
}

export interface IUsedPromotionCode extends IPromotionCode {
  UsedOn: string
  UsedByFirstName: string
  UsedByLastName: string
  UsedByEmail: string
  UsedByPhoneNumber: string
  ReferredByFirstName: string
  ReferredByLastName: string
  ReferredByEmail: string
  ReferredByPhoneNumber: string
  Active: boolean
  TotalCount: number
}

type GetPromotionCodesDataResponseModel = {
  GroupName: string;
  PromoCodes: IPromotionCode[];
};

type GetPromotionCodesResponseModel = {
  Count: number;
  Data: GetPromotionCodesDataResponseModel[];
};
export interface IPromotionCodeState {
  current: IPromotionCode | {};
  generatedCode: string;
  data: GetPromotionCodesResponseModel;
  loading: boolean;
  error: boolean;
}
const initialState: IPromotionCodeState = {
  current: {},
  generatedCode: "",
  data: {
    Count: 0,
    Data: [],
  },
  loading: false,
  error: false,
};
// promotionCodeReducer
export default function PromotionCodesSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case promotionCodeSymbols.GET_PROMOTION_CODES:
      return { ...state, loading: true, error: false };
    case promotionCodeSymbols.PROMOTION_CODES_SUCCESS:
      if (!state.data.Data?.length) {
        return {
          ...state,
          data: action.payload.Result,
          loading: false,
          error: false,
        };
      }

      return {
        ...state,
        data: {
          Count: action.payload.Result.Count,
          Data: [...state.data.Data, ...action.payload.Result.Data],
        },
        loading: false,
        error: false,
      };
    case promotionCodeSymbols.CREATE_PROMOTION_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false
      };
    case promotionCodeSymbols.SET_CURRENT:
      return {
        ...state,
        current: action.payload
      };
    case promotionCodeSymbols.PROMOTION_CODES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true
      };
    case promotionCodeSymbols.CLEAR_PROMOTION_CODES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false
      };
    case promotionCodeSymbols.PROMOTION_CODES_GENERATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        generatedCode: action.payload
      };
    default:
      return state;
  }
}
